import { OrderScenario } from '@pepperhq/types-sdk';
import { getLocalBasket } from 'components/basket/localStore';
import { useAuth } from 'lib/useAuth';
import { useLocalHistory } from 'lib/useLocalHistory';
import { ROUTES } from 'pages/routes';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useRouteScenario } from 'src/hooks/useRouteScenario';
import { basketRehydrate, setBasketDeliveryAddressId } from 'store/basket/basketActions';
import { ApplicationState } from 'store/store';

export function useDeliveryState(checkForAddress = true) {
    const dispatch = useDispatch();
    const { deliveryTimeMins, deliveryAddressId, hydrated } = useSelector(
        (state: ApplicationState) => state.basket
    );
    const { user, isGuest, isLoading } = useAuth();
    const { replace } = useLocalHistory();
    const [scenario] = useRouteScenario();
    const location = useLocation();
    React.useEffect(() => {
        if (!hydrated) {
            const basket = getLocalBasket() ?? undefined;
            dispatch(basketRehydrate(basket));
        }
    }, [dispatch, hydrated]);
    const selectedAddress = React.useMemo(() => {
        if (!deliveryAddressId) {
            return undefined;
        }
        return user?.addresses?.find(item => item._id === deliveryAddressId);
    }, [deliveryAddressId, user?.addresses]);
    const setSelectedAddress = React.useCallback(
        (addressId: string) => {
            dispatch(setBasketDeliveryAddressId(addressId));
        },
        [dispatch]
    );
    React.useEffect(() => {
        if (
            checkForAddress &&
            hydrated &&
            scenario === OrderScenario.DELIVERY &&
            !isLoading &&
            !!user &&
            !selectedAddress
        ) {
            replace(ROUTES.DELIVERY.ENTRY, {}, location.search);
        }
    }, [
        checkForAddress,
        hydrated,
        isGuest,
        isLoading,
        location.search,
        replace,
        scenario,
        selectedAddress,
        user
    ]);
    return { selectedAddress, setSelectedAddress, deliveryTimeMins };
}
